import { useUserInvitations } from 'app/agriculture/queries/invitations/useUserInvitations';
import { Heading } from 'app/agriculture/components/Heading/Heading';
import { RoundTable } from 'app/agriculture/components/RoundTable/RoundTable';
import { formatDistanceToNow } from 'date-fns';
import { Button } from 'app/agriculture/components/Button/Button';
import { useInvitationAcceptMutation } from 'app/agriculture/mutations/invitations/useInvitationAcceptMutation';
import { useInvitationRejectMutation } from 'app/agriculture/mutations/invitations/useInvitationRejectMutation';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { useUser } from 'app/agriculture/queries/users/useUser';
import { useFarmQuery } from 'app/agriculture/queries/farms/useFarmQuery';
import './UserInvitations.scss';

export function UserInvitations() {
    const invitations = useUserInvitations();
    const { mutate: acceptInvitation } = useInvitationAcceptMutation();
    const { mutate: rejectInvitation } = useInvitationRejectMutation();

    if (invitations.length === 0) return null;

    return (
        <div className="UserInvitations">
            <Heading>Invitations</Heading>
            <RoundTable
                columns={{
                    farm: { label: 'Farm Name', width: 'minmax(auto, 2fr)' },
                    when: { label: 'When' },
                    sender: { label: 'Invited By' },
                    decline: { label: '', width: 'min-content' },
                    accept: { label: '', width: 'min-content' },
                }}
                rows={invitations.map((invitation) => ({
                    id: invitation.id,
                    farm: (
                        <SuspenseWrapper>
                            <FarmName farmId={invitation.farmId} />
                        </SuspenseWrapper>
                    ),
                    when: formatDistanceToNow(invitation.createdAt, { addSuffix: true }),
                    sender: (
                        <SuspenseWrapper>
                            <UserName userId={invitation.creatorId} />
                        </SuspenseWrapper>
                    ),
                    decline: (
                        <Button
                            text="Decline"
                            variant="textonly"
                            onClick={() => {
                                rejectInvitation(invitation);
                            }}
                        />
                    ),
                    accept: (
                        <Button
                            text="Accept"
                            onClick={() => {
                                acceptInvitation(invitation);
                            }}
                        />
                    ),
                }))}
            />
        </div>
    );
}

export function FarmName({ farmId }: { farmId: number }) {
    const { name } = useFarmQuery({ farmId });

    return name;
}

export function UserName({ userId }: { userId: number }) {
    const { name } = useUser({ userId });

    return name ?? 'Unknown';
}
